/**
 * Textos da edição da redação (E171.F3, GUS-145 e GUS-46; ADR-0122 §2.7). E202.F3 (ADR-0145 §9): a
 * tela "Editor manual" saiu; ficam os rótulos das ações, os estados do rascunho, a prévia em PDF do
 * painel, a versão do texto e os avisos que a edição no documento da mesa reaproveita. As recusas são
 * as de `correcaoDoRascunho.erro`. Nada disto vai ao cliente.
 */
export const ptBREditor = {
  corrigir: 'Corrigir',
  corrigirNaMesa: 'Corrigir o texto na mesa',
  carregando: 'Carregando…',
  saida: {
    exame: 'Exame',
    riscos: 'Relatório de risco',
  },
  editor: {
    falta: {
      fundamento: 'Escreva o fundamento (ao menos {minimo} caracteres) para salvar.',
      texto: 'Escreva o texto do trecho para salvar.',
      longo: 'O texto passa de {maximo} caracteres; encurte para salvar.',
    },
  },
  acao: {
    substituir: 'Reescrever',
    remover: 'Tirar do documento',
    restaurar: 'Voltar ao original',
    escrever: 'Escrever a nota',
  },
  acaoDaNota: {
    remover: 'Tirar a nota',
  },
  // E184.F2 (GUS-145 item 2): o risco inteiro sai do relatório; juntar dois riscos é reescrever um e
  // tirar o outro.
  acaoDoRisco: {
    remover: 'Tirar o risco do documento',
  },
  gravacao: {
    parado: 'Sem alterações',
    guardando: 'Guardando o rascunho…',
    guardado: 'Rascunho salvo',
    falhou: 'Falha ao salvar o rascunho. O texto continua aqui; tente de novo.',
  },
  situacao: {
    vigente: 'Rascunho salvo',
    outra_versao: 'Rascunho de outra versão da análise',
    conflito: 'Conflito com uma edição mais recente',
  },
  situacaoAjuda: {
    outra_versao:
      'A análise mudou depois deste rascunho. Confira o texto contra o documento atual antes de salvar, ou descarte.',
    conflito:
      'Outra edição deste trecho foi salva depois do seu rascunho. Confira o que está no documento: salvar substitui a edição atual.',
  },
  naoAplicadas: {
    titulo: 'Edições que não se aplicam mais',
    ajuda:
      'O texto original destes trechos mudou na mesma versão da análise. Escreva a edição de novo no trecho atual, se ainda valer.',
  },
  previa: {
    rotulo: 'Prévia de {saida}',
    titulo: 'Prévia',
    preparando: 'Prévia em preparação. Ela aparece aqui quando o pacote terminar.',
    indisponivel: 'A prévia desta saída ainda não está disponível.',
    falhou: 'A prévia não pôde ser carregada. Atualize a página.',
  },
  // E184.F4 (GUS-145 item 6, ADR-0136 §5): o trecho que a conferência por regras apontou no card.
  apontado: {
    // E184.F4.C03 (QA de 29/10): o trecho fora dos editáveis é texto protegido, e a tela diz o
    // caminho que o corrige, em vez de só "não localizado".
    naoLocalizado: {
      exame:
        'A conferência por regras apontou “{trecho}”. Esse texto não é editável aqui: é um dado apurado no exame (tabela, quadro ou leitura do material). Para mudá-lo, refaça a análise do que o originou na pré-análise, ou registre a revisão na mesa. Procure-o no documento abaixo.',
      riscos:
        'A conferência por regras apontou “{trecho}”. Esse texto não é editável aqui: é o Fato e fonte de um risco, que vem do exame. Para corrigir, clique no texto do risco no mapa e reescreva, ou tire o risco do relatório.',
    },
  },
  rodape: {
    textoOriginal: 'texto original',
    textoEditado: 'texto {codigo}',
  },
};
